export interface Project {
  id: string;
  name: string;
  category: string;
  tagline: string;
  description: string;
  story: string;
  icon: string;
  image?: string;
  imageAlt?: string;
  link: string;
  platform: string;
  features: { title: string; description: string }[];
  legacyId: string;
  socialLinks?: { label: string; url: string }[];
}

export const projects: Project[] = [
  {
    "id": "fable",
    "name": "Fable: The AI Story Generator",
    "category": "Stories & imagination",
    "tagline": "Your idea. Your story.",
    "description": "Turn an idea into a story you can read, hear and share. Create original characters, illustrated books, expressive audio stories and animated videos with Fable.",
    "story": "Fable gives people a place to make the stories they want to tell. Start with an idea, shape your characters and choose how the story comes to life. From an illustrated adventure to an audio performance or an animated scene, the creative direction stays yours.",
    "icon": "/images/fable-icon.png",
    "image": "/images/fable-worlds.jpg",
    "imageAlt": "Fable story characters with a dragon, a knight, a singer and glowing butterflies",
    "link": "https://thefableapp.com",
    "platform": "Web, iOS & Android",
    "legacyId": "fable-personalized-ai-stories",
    "features": [
      {
        "title": "Make it your story",
        "description": "Create characters and develop original adventures around your ideas."
      },
      {
        "title": "Hear the performance",
        "description": "Bring dialogue and narration to life with expressive voices and audio."
      },
      {
        "title": "Choose your format",
        "description": "Create illustrated stories, audio experiences, animated videos and books."
      },
      {
        "title": "Create wherever you are",
        "description": "Explore Fable on the web or with the iOS and Android apps."
      }
    ],
    "socialLinks": [
      {
        "label": "Instagram",
        "url": "https://www.instagram.com/thefableapp/"
      },
      {
        "label": "X",
        "url": "https://x.com/thefableapp"
      },
      {
        "label": "TikTok",
        "url": "https://www.tiktok.com/@thefableapp"
      }
    ]
  },
  {
    "id": "veld",
    "name": "Veld AI",
    "category": "Agriculture & AI",
    "tagline": "Breed with perspective.",
    "description": "Herd records, family trees and breeding plans in one place. Veld helps South African cattle breeders work with their own data and ask better questions about their herd.",
    "story": "Good breeding decisions start with knowing your animals. Veld brings animal records, pedigrees, recorded breeding values and farm observations into a shared workspace. Ask Veld helps you explore those records in everyday language, while you stay in control of what is saved and how a breeding plan is used.",
    "icon": "/images/veld-icon.png",
    "image": "/images/veld-herd.webp",
    "imageAlt": "Illustration of a cow and calf in the South African countryside",
    "link": "https://veldai.app",
    "platform": "Web application",
    "legacyId": "veld-ai",
    "features": [
      {
        "title": "Keep your herd together",
        "description": "Manage animal IDs, photos, weights, calvings and notes with your farm team."
      },
      {
        "title": "Explore recorded genetics",
        "description": "Follow family trees, compare available breeding values and review possible cattle pairings."
      },
      {
        "title": "Bring your records with you",
        "description": "Import spreadsheets or bring cattle records in from your authorised Logix account."
      },
      {
        "title": "Ask Veld",
        "description": "Ask questions about your animals and review editable record drafts from supported photos and documents."
      }
    ]
  },
  {
    "id": "gruvi",
    "name": "Gruvi",
    "category": "Content distribution for agents",
    "tagline": "Content distribution. Built for agents.",
    "description": "Content distribution for agents and teams. Upload your content and thumbnails, publish or schedule to connected channels, and track performance in one place.",
    "story": "Gruvi handles the step between finished content and your audience. Bring the videos and thumbnails you already have, connect your social accounts, and publish through the dashboard or an agent API. Keep your posts, delivery status and available channel analytics together.",
    "icon": "/images/gruvi-icon.png",
    "link": "https://agentgruvi.com",
    "platform": "Web dashboard & agent API",
    "legacyId": "gruvi-ai-content-on-autopilot",
    "features": [
      {
        "title": "Bring your own content",
        "description": "Upload finished videos and custom thumbnails without a generation workflow."
      },
      {
        "title": "Publish across channels",
        "description": "Post or schedule to connected X, Instagram, TikTok, YouTube, Facebook and LinkedIn accounts."
      },
      {
        "title": "Work with your agent",
        "description": "Use an agent key and documented API to upload, schedule and check delivery status."
      },
      {
        "title": "See what happened",
        "description": "Review scheduled posts, publishing results and available TikTok and YouTube analytics."
      }
    ],
    "socialLinks": [
      {
        "label": "Instagram",
        "url": "https://www.instagram.com/gruvimusic"
      },
      {
        "label": "TikTok",
        "url": "https://www.tiktok.com/@gruvimusic"
      },
      {
        "label": "YouTube",
        "url": "https://www.youtube.com/@gruvimusicai"
      },
      {
        "label": "Facebook",
        "url": "https://www.facebook.com/profile.php?id=61585764854944"
      }
    ]
  }
];

export const featuredProjects = projects;
